export function _bridge<T>(moduleName: any, module: any): T {
  window.define(moduleName, function () {
    return module;
  });
  seajs.use(moduleName, function () { });
}